var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCycle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13 9a3 3 0 1 1 0 6 3 3 0 0 1 0-6ZM3 9a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm6.169-5.27.087.09 1.51 1.746 1.589.549a1 1 0 0 1 .65 1.16l-.032.112a1 1 0 0 1-1.159.65l-.112-.032-1.843-.636a1 1 0 0 1-.337-.198l-.092-.093-.959-1.109L7.041 7.5l1.691 1.819a1 1 0 0 1 .26.556L9 10v3a1 1 0 0 1-1.993.117L7 13l-.001-2.608-2.056-2.211a1 1 0 0 1-.081-1.264l.082-.1 2.825-3.026a1 1 0 0 1 1.4-.061ZM13 10.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm-10 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM11 1a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCycle);
export default __webpack_public_path__ + "static/media/cycle.64e304e0ebd8abc03144abbd729e9e41.svg";
export { ForwardRef as ReactComponent };